import { isBefore, startOfDay } from 'date-fns'

import type {
  CustomProps,
  DateRangePickerType,
  DefaultOption,
  FocusedInputType,
  SelectorDate,
  TooltipProps,
} from 'common/components/dateRange/interfaces'

import DateRange from './DateRange'
import { options } from './defaultOptions'

/** day >= comparisonDay (inclusive, day-level comparison) */
const isInclusivelyAfterDay = (day: Date, comparisonDay: Date): boolean =>
  !isBefore(startOfDay(day), startOfDay(comparisonDay))

export default DateRange

export { isInclusivelyAfterDay, options }

export type {
  CustomProps,
  DefaultOption,
  SelectorDate,
  DateRangePickerType,
  FocusedInputType,
  TooltipProps,
}
